export default {
  wrapper: {
    margin: '10px 0 40px'
  }
};